<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { counter } = defineProps<{ counter?: number }>();
</script>

<template>
  <button class="button-glass">
    <div v-if="counter !== undefined" class="button-glass__badge">
      <Text font="body-medium-12" color="white">{{ counter }}</Text>
    </div>
    <slot />
  </button>
</template>

<style scoped>
  .button-glass {
    width: 64px;
    height: 64px;
    background-color: var(--sf-base-background-tabbar);
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow:
      0px 0px 3px 0px #3f45541f,
      0px 8px 20px 0px #3f45542e,
      1px 1px 0px 0px #ffffff99 inset,
      -1px -1px 0px 0px #ffffff66 inset;
    backdrop-filter: blur(12px);
  }

  .button-glass__badge {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--sf-base-icon-error);
    border-radius: 100%;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 8px;
    right: 8px;
  }
</style>
